<div class="w-full">
  <div
    class="border-default flex flex-col gap-2 rounded-lg border bg-zinc-50 p-2 dark:border-zinc-600 dark:bg-zinc-900">
    @for (entry of entries(); track $index; let i = $index) {
      <div class="flex items-center gap-2">
        <input
          type="text"
          [id]="id() + '-key-' + i"
          [value]="entry.key"
          (input)="updateKey(i, $any($event.target).value)"
          (blur)="onBlur()"
          placeholder="{{ 'form.key' | translate }}"
          class="border-default bg-elevated text-text-primary placeholder-text-tertiary focus:border-accent-focus focus:ring-accent-focus min-w-[100px] flex-1 rounded border px-2 py-1 text-sm outline-none focus:ring-1" />

        <app-select
          class="w-28"
          [id]="id() + '-type-' + i"
          [items]="valueTypeItems()"
          [value]="entry.valueType"
          (valueChange)="changeValueType(i, $any($event))" />

        @switch (entry.valueType) {
          @case ('boolean') {
            <label class="flex flex-1 cursor-pointer items-center gap-2">
              <input
                type="checkbox"
                [id]="id() + '-value-' + i"
                [checked]="entry.value === true"
                (change)="onBooleanChange(i, $event)"
                (blur)="onBlur()"
                class="border-default focus:ring-accent-focus h-4 w-4 rounded text-teal-600 dark:border-zinc-600 dark:bg-zinc-800" />
              <span class="text-text-secondary text-sm">{{
                entry.value === true
                  ? ('common.true' | translate)
                  : ('common.false' | translate)
              }}</span>
            </label>
          }
          @case ('number') {
            <input
              type="number"
              [id]="id() + '-value-' + i"
              [value]="entry.value"
              (input)="updateValue(i, $any($event.target).value)"
              (blur)="onBlur()"
              placeholder="{{ 'form.value' | translate }}"
              class="border-default bg-elevated text-text-primary placeholder-text-tertiary focus:border-accent-focus focus:ring-accent-focus min-w-[100px] flex-1 rounded border px-2 py-1 text-sm outline-none focus:ring-1" />
          }
          @default {
            <input
              type="text"
              [id]="id() + '-value-' + i"
              [value]="entry.value"
              (input)="updateValue(i, $any($event.target).value)"
              (blur)="onBlur()"
              placeholder="{{ 'form.value' | translate }}"
              class="border-default bg-elevated text-text-primary placeholder-text-tertiary focus:border-accent-focus focus:ring-accent-focus min-w-[100px] flex-1 rounded border px-2 py-1 text-sm outline-none focus:ring-1" />
          }
        }

        <button
          type="button"
          (click)="removeEntry(i)"
          class="inline-flex h-6 w-6 items-center justify-center rounded-full text-zinc-500 hover:bg-red-100 hover:text-red-600 dark:text-zinc-400 dark:hover:bg-red-900 dark:hover:text-red-300">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    } @empty {
      <p class="text-text-tertiary text-center text-sm">
        {{ 'common.no_items' | translate }}
      </p>
    }

    <button
      type="button"
      (click)="addEntry()"
      class="mt-1 flex items-center gap-1 self-start rounded bg-green-600 px-2 py-1 text-xs text-white hover:bg-green-700 dark:bg-green-700 dark:hover:bg-green-600">
      <i [class]="ICONS.plus"></i>
      {{ 'common.add' | translate }}
    </button>
  </div>
</div>
